import { BlocksPipes } from '../../../../common/types/api/page'

export function addPipes(id: number): BlocksPipes {
    return {
        id,
        query: `=> sys.timestamp():dateformat('yyyy-MM-dd') as date, 100:random:round(2) as value,  'text edit' as msg at the end`,
        span: 'last hour',
        template: `
        <h1> 
            Report X  \${event.msg}
        </h1>
            <br/>
        <label> 
            Date:  \${event.date} 
        </label> 
            <br/>
        <label> 
            Value:  \${event.value} 
        </label> 
  `,
        unfollowSpan: false
    }
}
